export const ArLocale = {
    page: {
        txtTitle: 'UNVOX | إزالة الغناء فورًا',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'شعار unvox',
        },
        action: {
            txtBack: 'رجوع',
            txtRetry: 'إعادة المحاولة',
            txtStartOver: 'ابدأ من جديد',
        },
        job: {
            txtCheckingStatus: 'جارٍ التحقق من حالة المهمة',
            txtIdLabel: 'معرّف المهمة',
        },
        footer: {
            linkPrivacyPolicy: 'سياسة الخصوصية',
            linkTerms: 'الشروط',
            linkRefunds: 'الاسترجاع',
            linkSupport: 'الدعم',
            txtAllRightsReserved: 'جميع الحقوق محفوظة.',
            txtBugReportsAndFeatures: 'تقارير الأخطاء وطلبات الميزات',
        },
        share: {
            title: 'UNVOX | إزالة غناء الأغاني بنقرة واحدة',
            text: 'حوّل أغانيك المفضلة بسهولة إلى مقاطع موسيقية جاهزة للكاريوكي!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'إزالة الغناء بنقرة واحدة',
            txtHeroSubtitle: 'مقاطع موسيقية فورية من ملفك أو مباشرة من YouTube',
            txtInputTypeLabel: 'نوع الإدخال',
            txtInputTypeFile: 'رفع ملف صوتي',
            txtInputTypeYoutube: 'رابط YouTube',
            txtInputFilePick: 'اختر ملفًا',
            txtInputFileSub: 'تنسيقات صوت شائعة ({{formats}})، حتى {{size}} MB.',
            txtPreviewAction: 'إزالة الغناء',
            txtPreviewFailed: 'حدث خطأ غير معروف. يرجى المحاولة لاحقًا.',
            txtUploadSelectFile: 'لم يتم اختيار ملف بعد',
            txtYoutubeLabel: 'رابط YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'الصق رابط YouTube عام.',
            txtYoutubeMissing: 'يرجى لصق رابط YouTube.',
            txtYoutubeInvalid: 'أدخل رابط YouTube صالحًا.',
            txtYoutubeTooLong: 'مدة هذا الفيديو أكثر من 15 دقيقة. يرجى اختيار فيديو أقصر.',
            txtCheckoutUploadFailed: 'فشل الرفع. يرجى المحاولة مرة أخرى.',
            txtUploadMissing: 'يرجى اختيار ملف قبل الرفع.',
            txtFileTypeInvalid: 'نوع ملف غير مدعوم. يرجى رفع ملف صوتي (مثل {{formats}}).',
            txtFileTooLarge: 'الملف كبير جدًا. الحد الأقصى {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'تعذر إنشاء المعاينة',
            txtUnavailableBody: 'حدث خطأ غير معروف. يرجى المحاولة لاحقًا.',
            txtPreparingTitle: 'جارٍ تجهيز المعاينة',
            txtPreparingBody: 'قد يستغرق ذلك حتى دقيقتين',
        },
        payment: {
            txtUnavailableTitle: 'تعذر إنشاء المعاينة',
            txtUnavailableBody: 'حدث خطأ غير معروف. يرجى المحاولة لاحقًا.',
            txtPreparingTitle: 'جارٍ تجهيز المعاينة',
            txtCheckoutCancelledBody: 'لم يتم تحصيل أي مبلغ. يمكنك المحاولة مرة أخرى في أي وقت.',
            txtTrackPreviewLabel: 'معاينة المقطع',
            txtTrackPreviewHelper: 'هذه المعاينة مقطع مدته 15 ثانية من مسارك للتقييم',
            txtEmailLabel: 'البريد الإلكتروني',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'سنستخدم هذا لإرسال رابط التحميل الخاص بك.',
            txtCheckoutAction: 'إزالة الغناء مقابل {{price}} فقط',
            txtCheckoutActionFallback: 'إزالة الغناء',
            txtCheckoutFailed: 'تعذر بدء الدفع. يرجى المحاولة مرة أخرى.',
            txtInvalidEmail: 'أدخل بريدًا إلكترونيًا صالحًا.',
        },
        processing: {
            txtMissingTitle: 'معرّف المهمة مفقود',
            txtMissingBody: 'هذه الصفحة تحتاج إلى معرّف مهمة. يرجى بدء معاينة جديدة.',
            txtMissingAction: 'العودة للرفع',
            txtStatusFailed: 'تعذر جلب حالة المهمة. يرجى المحاولة مرة أخرى.',
            txtErrorTitle: 'حدث خطأ ما',
            txtSupportAction: 'التواصل مع الدعم',
            txtConfirmingTitle: 'جارٍ تأكيد الدفع',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'جارٍ التحقق من التحديثات',
            txtWorkingTitle: 'جارٍ معالجة المسار الكامل',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'ابدأ واحدًا آخر',
            txtReadyTitle: 'التحميل جاهز',
            txtReadyBody: 'المقطع الموسيقي جاهز للتنزيل.',
            txtDownloadAction: 'تنزيل',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'ابدأ واحدًا آخر',
        },
        invalidJob: {
            txtTitle: 'معرّف مهمة غير صالح',
            txtBody: 'تعذر العثور على هذه المهمة. يرجى بدء رفع جديد.',
            txtAction: 'ابدأ من جديد',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'الدعم',
            txtTitle: 'التواصل مع الدعم',
            txtLastUpdatedLabel: 'آخر تحديث',
            txtLastUpdatedDate: '9 فبراير 2026',
            txtSectionEmailTitle: 'البريد الإلكتروني',
            txtSectionEmailBodyPrefix: 'راسلنا على',
            txtSectionIncludeJobIdTitle: 'ضمّن معرّف مهمتك',
            txtSectionIncludeJobIdBody: 'يرجى تضمين معرّف المهمة حتى نتمكن من العثور عليها بسرعة. إذا دفعت، أضف البريد الإلكتروني المستخدم عند الدفع.',
            txtSectionBugReportsTitle: 'تقارير الأخطاء',
            txtSectionBugReportsBody: 'يمكنك أيضًا إرسال تقارير الأخطاء وطلبات الميزات عبر الرابط في التذييل.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'ملاحظات',
            txtTitle: 'تقارير الأخطاء وطلبات الميزات',
            txtSubtitle: 'UNVOX ما زال في مرحلة مبكرة. إذا شعرت أن هناك خطأ أو لديك فكرة، أرسلها. التقارير الواضحة هي أسرع طريقة لإطلاق الإصلاحات.',
            txtWhatToIncludeTitle: 'ما الذي يجب تضمينه',
            txtChecklistExpectedVsActual: 'ما الذي توقعته مقابل ما حدث',
            txtChecklistSteps: 'خطوات إعادة المشكلة (1، 2، 3)',
            txtChecklistBrowserOs: 'متصفحك ونظام التشغيل',
            txtChecklistJobId: 'معرّف المهمة (إذا كان مرتبطًا برفع)',
            txtTipTitle: 'نصيحة',
            txtTipBody: 'إذا كنت تراسلنا عبر البريد، يمكنك الرد مباشرة على رسالة التسليم التي استلمتها ولصق القالب.',
            txtTemplateTitle: 'قالب نسخ ولصق',
            txtTemplateBody: 'تقرير خطأ / طلب ميزة\n\nالنوع: bug | feature\nالملخص:\n\nالتفاصيل:\n- ماذا حدث:\n- ما الذي توقعته:\n- خطوات إعادة المشكلة:\n  1.\n- المتصفح/النظام:\n\nاختياري:\n- معرّف المهمة:\n- رابط YouTube:\n- لقطة شاشة/فيديو:\n',
            txtTemplatePageLabel: 'الصفحة',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'نسخ القالب',
            txtCopyActionCopied: 'تم النسخ',
            txtCopyActionFailed: 'فشل النسخ',
            txtCopyHelpFailed: 'تم حظر الوصول إلى الحافظة. لا يزال بإمكانك تحديد النص أعلاه ونسخه يدويًا.',
            txtCopyHelpIdle: 'لا يتم إرسال أي شيء من هنا تلقائيًا. هذه الصفحة تساعدك فقط على تنسيق تقرير جيد.',
        },
    },
};
